import { combineReducers } from "redux";
import { Constant } from "../../Constant";
import { fullJsonObjToFieldValue } from "../../Utils";
import Mode from "../../constant/Mode";

const formId = (state = "", action) => {
    let { type, payload } = action;
    switch (type) {
        case Constant.action.INITIAL_APPROVAL:
            return payload.formId;
        case Constant.action.INITIAL_FORM:
            return payload;
        case Constant.action.CLEAR_FORM:
            return "";
        default:
            return state;
    }
};

const currentStep = (state = "", action) => {
    let { type, payload } = action;
    switch (type) {
        case Constant.action.INITIAL_FORM:
        case Constant.action.CLEAR_FORM:
            return "";
        case Constant.action.SET_CURRENT_STEP:
            return payload;
        case Constant.action.INITIAL_APPROVAL:
            return "Approval";
        default:
            return state;
    }
};

const initialStep = (state = "", action) => {
    let { type, payload } = action;
    switch (type) {
        case Constant.action.SET_INITIAL_STEP:
            return payload;
        case Constant.action.CLEAR_FORM:
            return "";
        default:
            return state;
    }
};

const fieldValues = (state = {}, action) => {
    let { type, payload } = action;
    switch (type) {
        case Constant.action.INITIAL_FORM:
        case Constant.action.CLEAR_FORM:
            return {};
        case Constant.action.SET_FIELD_VALUES:
            return { ...state, [payload.stepName]: payload.stepValues };
        case Constant.action.SET_FULL_FIELD_VALUS:
            return { ...payload };
        case Constant.action.INITIAL_APPROVAL:
            if (!payload.fullJsonObj) {
                window.location.href = "/eformss/main";
            }
            return fullJsonObjToFieldValue(
                JSON.parse(payload.fullJsonObj),
                payload
            );
        default:
            return state;
    }
};

const referenceId = (state = "", action) => {
    const { type, payload } = action;
    switch (type) {
        case Constant.action.INITIAL_APPROVAL:
        case Constant.action.SUBMIT_FORM.DONE:
            return payload.referenceNumber;
        case Constant.action.SAVE_FORM107_DRAFT:
            return payload;
        case Constant.action.CLEAR_FORM:
            return "";
        default:
            return state;
    }
};

const mode = (state = "", action) => {
    const { type, payload } = action;
    switch (type) {
        case Constant.action.INITIAL_FORM:
            return Mode.formFilling;
        case Constant.action.INITIAL_APPROVAL:
            return payload.mode;
        case Constant.action.SET_MODE:
            return payload;
        case Constant.action.CLEAR_FORM:
            return "";
        default:
            return state;
    }
};

const status = (state = -1, action) => {
    const { type, payload } = action;
    switch (type) {
        case Constant.action.INITIAL_APPROVAL:
        case Constant.action.SUBMIT_FORM.DONE:
            return payload.status;
        case Constant.action.CLEAR_FORM:
            return -1;
        default:
            return state;
    }
};

const submittedDate = (state = "", action) => {
    const { type, payload } = action;
    switch (type) {
        case Constant.action.INITIAL_APPROVAL:
            return payload.createdDateTime;
        case Constant.action.CLEAR_FORM:
            return "";
        default:
            return state;
    }
};

const lastModifiedDate = (state = "", action) => {
    const { type, payload } = action;
    switch (type) {
        case Constant.action.INITIAL_APPROVAL:
            return payload.lastModifiedDateTime;
        case Constant.action.CLEAR_FORM:
            return "";
        default:
            return state;
    }
};

const params = (state = {}, action) => {
    const { type, payload } = action;
    switch (type) {
        case Constant.action.GET_PARAMS.DONE:
            return { ...payload };
        case Constant.action.INITIAL_APPROVAL:
            return payload.params;
        case Constant.action.CLEAR_FORM:
            return {};
        default:
            return state;
    }
};

const msgApprove = (state = "", action) => {
    const { type, payload } = action;
    switch (type) {
        case Constant.action.INITIAL_APPROVAL:
            return payload?.msgApprove || "";
        case Constant.action.CLEAR_FORM:
            return "";
        default:
            return state;
    }
};

const msgApprove2 = (state = "", action) => {
    const { type, payload } = action;
    switch (type) {
        case Constant.action.INITIAL_APPROVAL:
            return payload?.msgApprove2 || "";
        case Constant.action.CLEAR_FORM:
            return "";
        default:
            return state;
    }
};
const msgApprove3 = (state = "", action) => {
    const { type, payload } = action;
    switch (type) {
        case Constant.action.INITIAL_APPROVAL:
            return payload?.msgApprove3 || "";
        case Constant.action.CLEAR_FORM:
            return "";
        default:
            return state;
    }
};
const msgApprove4 = (state = "", action) => {
    const { type, payload } = action;
    switch (type) {
        case Constant.action.INITIAL_APPROVAL:
            return payload?.msgApprove4 || "";
        case Constant.action.CLEAR_FORM:
            return "";
        default:
            return state;
    }
};

const msgReview = (state = "", action) => {
    const { type, payload } = action;
    switch (type) {
        case Constant.action.INITIAL_APPROVAL:
            return payload?.msgReview || "";
        case Constant.action.CLEAR_FORM:
            return "";
        default:
            return state;
    }
};

const replySlipOption = (state = {}, action) => {
    const { type, payload } = action;
    switch (type) {
        case Constant.action.SET_REPLY_SLIP_OPTION:
            return payload;
        case Constant.action.CLEAR_FORM:
            return {};
        default:
            return state;
    }
};

const version = (state = "", action) => {
    const { type, payload } = action;
    switch (type) {
        case Constant.action.INITIAL_APPROVAL:
            return payload?.version !== "" ? payload?.version : "";
        case Constant.action.CLEAR_FORM:
            return "";
        default:
            return state;
    }
};

const formLanguage = (state = "", action) => {
    const { type, payload } = action;
    switch (type) {
        case Constant.action.INITIAL_APPROVAL:
            switch (payload.formLanguage) {
                case "Cht":
                    return "tc";
                case "Chs":
                    return "sc";
                case "Eng":
                    return "en";
            }
            break;
        case Constant.action.CLEAR_FORM:
            return "";
        default:
            return state;
    }
};

const editRole = (state = "", action) => {
    const { type, payload } = action;
    switch (type) {
        case Constant.action.INITIAL_APPROVAL:
            return payload.editRole || "";
        case Constant.action.CLEAR_FORM:
            return "";
        default:
            return state;
    }
};

const scrn = (state = "", action) => {
    const { type, payload } = action;
    switch (type) {
        case Constant.action.INITIAL_APPROVAL:
            return payload.scrn;
        case Constant.action.CLEAR_FORM:
            return "";
        default:
            return state;
    }
};

const stepSequence = (state = [], action) => {
    const { type, payload } = action;
    switch (type) {
        case Constant.action.SET_STEP_SEQUENCE:
            return payload;
        case Constant.action.CLEAR_FORM:
        case Constant.action.RESET_STEP_SEQUENCE:
            return [];
        default:
            return state;
    }
};

const form101SubmitedJob = (state = [], action) => {
    const { type, payload } = action;
    switch (type) {
        case Constant.action.SET_FORM101_SUBMITED_JOB:
            return payload;
        case Constant.action.CLEAR_FORM:
            return [];
        default:
            return state;
    }
};

const formEnterLocalTime = (state = "", action) => {
    const { type, payload } = action;
    switch (type) {
        case Constant.action.SET_FORM_ENTER_LOCALTIME:
            return payload;
        case Constant.action.CLEAR_FORM:
            return "";
        default:
            return state;
    }
};

const workflowType = (state = "", action) => {
    let { type, payload } = action;
    switch (type) {
        case Constant.action.INITIAL_APPROVAL:
            return payload.workflowType || "";
        case Constant.action.CLEAR_FORM:
            return "";
        default:
            return state;
    }
};

const release = (state = "", action) => {
    const { type, payload } = action;
    switch (type) {
        case Constant.action.INITIAL_APPROVAL:
            return payload.release || "";
        case Constant.action.CLEAR_FORM:
            return "";
        default:
            return state;
    }
};

const applicantCanWithdrawal = (state = "", action) => {
    const { type, payload } = action;
    switch (type) {
        case Constant.action.INITIAL_APPROVAL:
            return payload.applicantCanWithdrawal || null;
        case Constant.action.CLEAR_FORM:
            return "";
        default:
            return state;
    }
};

const createdDateTime = (state = "", action) => {
    const { type, payload } = action;
    switch (type) {
        case Constant.action.INITIAL_APPROVAL:
            return payload.createdDateTime || "";
        case Constant.action.CLEAR_FORM:
            return "";
        default:
            return state;
    }
};
const isClosedSchool = (state = "", action) => {
    const { type, payload } = action;
    switch (type) {
        case Constant.action.INITIAL_APPROVAL:
            return payload.isClosedSchool || false;
        case Constant.action.CLEAR_FORM:
            return false;
        default:
            return state;
    }
};

const secondApproverNeedSign = (state = "", action) => {
    const { type, payload } = action;
    switch (type) {
        case Constant.action.INITIAL_APPROVAL:
            return payload.secondApproverNeedSign || false;
        case Constant.action.CLEAR_FORM:
            return false;
        default:
            return state;
    }
};

const form = combineReducers({
    formId,
    currentStep,
    initialStep,
    fieldValues,
    referenceId,
    mode,
    status,
    submittedDate,
    lastModifiedDate,
    params,
    msgApprove,
    msgApprove2,
    msgApprove3,
    msgApprove4,
    msgReview,
    replySlipOption,
    version,
    formLanguage,
    scrn,
    stepSequence,
    form101SubmitedJob,
    formEnterLocalTime,
    workflowType,
    editRole,
    release,
    applicantCanWithdrawal,
    createdDateTime,
    isClosedSchool,
    secondApproverNeedSign,
});

export default form;

// export default function form(state = initState, action) {
//     let { type, payload } = action;
//     switch (type) {
//         case Constant.action.INITIAL_FORM:
//             return {
//                 formId: payload,
//                 currentStep: "",
//                 fieldValues: fieldValues,
//             };
//         case Constant.action.SET_CURRENT_STEP:
//             return Object.assign({}, state, {
//                 currentStep: payload,
//             });

//         default:
//             return state;
//     }
// }
